var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.875,
    height: 13.22,
    viewBox: "0 0 14.875 13.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-edit",
    "data-name": "Icon awesome-edit",
    d: "M10.4,2.153l2.329,2.329a.253.253,0,0,1,0,.356l-5.64,5.64-2.4.266a.5.5,0,0,1-.555-.555l.266-2.4,5.64-5.64A.253.253,0,0,1,10.4,2.153Zm4.184-.591L13.32.3a1.01,1.01,0,0,0-1.426,0l-.914.914a.253.253,0,0,0,0,.356L13.31,3.9a.253.253,0,0,0,.356,0l.914-.914a1.01,1.01,0,0,0,0-1.426ZM9.917,8.945v2.629H1.653V3.31H7.587a.318.318,0,0,0,.22-.09L8.84,2.187a.31.31,0,0,0-.22-.529H1.24A1.24,1.24,0,0,0,0,2.9v9.09a1.24,1.24,0,0,0,1.24,1.24h9.09a1.24,1.24,0,0,0,1.24-1.24V7.912a.31.31,0,0,0-.529-.22L10.007,8.725A.318.318,0,0,0,9.917,8.945Z",
    transform: "translate(0 -0.007)",
    fill: "#222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.59a4e3df8634ccb4b8c2387b9ddbc057.svg";
export { ForwardRef as ReactComponent };